module.exports = __webpack_public_path__ + "8b6b65d1d2852d03bab184f71780a539.svg";